import { motion } from "framer-motion";
import { Church, MapPin, Calendar, HeartHandshake, ArrowUpRight } from "lucide-react";
import { HIGHLIGHTS } from "@/data/content";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import { scrollToId } from "@/lib/scroll";

const ICONS = { Church, MapPin, Calendar, HeartHandshake };

export default function Highlights() {
  return (
    <section id="destaques" className="px-4 sm:px-8 lg:px-16 py-16 lg:py-24">
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5DEC9] border border-[#E5DEC9]"
      >
        {HIGHLIGHTS.map((h, i) => {
          const Icon = ICONS[h.icon];
          return (
            <motion.button
              key={h.testid}
              data-testid={h.testid}
              variants={fadeUp}
              onClick={() => scrollToId(h.id)}
              className="group relative bg-[#FBF9F4] hover:bg-[#4A0E17] text-left p-8 lg:p-10 transition-colors duration-500"
            >
              <span className="font-display text-xs text-[#C5A059]">0{i + 1}</span>
              <Icon className="mt-6 h-8 w-8 text-[#4A0E17] group-hover:text-[#C5A059] transition-colors duration-500" strokeWidth={1.5} />
              <h3 className="font-display mt-6 text-lg font-bold text-[#1C1917] group-hover:text-[#FBF9F4] transition-colors duration-500">{h.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#1C1917]/60 group-hover:text-[#FBF9F4]/70 transition-colors duration-500">{h.desc}</p>
              <ArrowUpRight className="absolute top-8 right-8 h-4 w-4 text-[#C5A059] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </motion.button>
          );
        })}
      </motion.div>
    </section>
  );
}
